import { render } from "./AdminAdmins.vue?vue&type=template&id=6bc8f836&scoped=true"
import script from "./AdminAdmins.vue?vue&type=script&lang=js"
export * from "./AdminAdmins.vue?vue&type=script&lang=js"

import "./AdminAdmins.vue?vue&type=style&index=0&id=6bc8f836&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc8f836"]])

export default __exports__